import { useNavegate } from 'App/hooks';
import { toStatusType } from 'App/rtk';
import { useToastStatus } from 'commons/hooks';
import { logMoreDiscountsModalOptionCreated } from 'domains/Marketing/components/MoreDiscounts';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import {
  DISCOUNT_OPTION_ID_QUERY_PARAM,
  MARKETING_ROUTES,
} from 'domains/Marketing/marketingRoutes';
import {
  ConfirmScopeFreeShippingModal,
  FreeShippingForm,
  FreeShippingPage,
} from '../../components';
import { useCreateFreeShippingMutation } from '../../freeShippingApi';
import { useFreeShippingForm } from '../../hooks';
import { FreeShippingFormState } from '../../types';
import { payloadDigest } from '../../utils';
import { freeShippingDefault } from '../constants';
import { FreShippingPageModes } from '../types';

export function NewFreeShippingPage() {
  const t = useTranslationMarketing('freeShipping.settingsPage.new');
  const { getQueryParam, goTo } = useNavegate();

  const [createFreeShipping, { status }] = useCreateFreeShippingMutation();

  const discountOptionId = getQueryParam(DISCOUNT_OPTION_ID_QUERY_PARAM);

  const handleConfirm = (data: FreeShippingFormState) => {
    createFreeShipping(payloadDigest(data));
    if (discountOptionId !== null) {
      logMoreDiscountsModalOptionCreated(discountOptionId);
    }
  };

  const {
    values,
    errors,
    isDirty,
    showConfirmModal,
    handleChangeMethods,
    handleChangeCategories,
    handleChangeZones,
    handleChange,
    handleOnSubmit,
    closeConfirmModal,
  } = useFreeShippingForm({
    initialValues: freeShippingDefault,
    onSubmit: handleConfirm,
  });

  const createStatus = toStatusType(status);

  useToastStatus({
    error: t('error'),
    success: t('success'),
    status: createStatus,
    onSuccess: () => goTo(MARKETING_ROUTES.freeShippingList),
  });

  return (
    <FreeShippingPage
      values={values}
      status={createStatus}
      isDirty={isDirty}
      onSave={handleOnSubmit}
      mode={FreShippingPageModes.NEW}
    >
      <FreeShippingForm
        values={values}
        errors={errors}
        onChange={handleChange}
        onChangeMethods={handleChangeMethods}
        onChangeCategories={handleChangeCategories}
        onChangeZones={handleChangeZones}
      />
      <ConfirmScopeFreeShippingModal
        values={values}
        show={showConfirmModal}
        onClose={closeConfirmModal}
        onConfirm={handleConfirm}
      />
    </FreeShippingPage>
  );
}
